import { HomeDateRangeEnum, HomeIntentEnum } from './types';

const iconClass = 'h-6 w-6 max-sm:h-5 max-sm:w-5';

const dateIconClass = 'h-[1.125rem] w-[1.125rem]';

export const getDateRangeOptions = (iconClassName: string = dateIconClass) => [
  {
    label: 'Today',
    value: HomeDateRangeEnum.Today,
    icon: <img src="/images/app/bolt.svg" className={iconClassName} />,
  },
  {
    label: 'This week',
    value: HomeDateRangeEnum.ThisWeek,
    icon: <img src="/images/app/week.svg" className={iconClassName} />,
  },
  {
    label: 'This month',
    value: HomeDateRangeEnum.ThisMonth,
    icon: <img src="/images/programming/camp.png" className={iconClassName} />,
  },
];

export const getIntentOptions = () => [
  {
    label: 'Join a game',
    value: HomeIntentEnum.JoinGame,
    icon: <img src="/images/programming/socials.png" className={iconClass} />,
  },
  {
    label: 'Compete',
    value: HomeIntentEnum.Compete,
    icon: (
      <img
        src="/images/player-home-v2/search-bar-icons/tournament-gradient.svg"
        className="h-[1.125rem] w-6 object-contain max-sm:h-[0.9375rem] max-sm:w-5"
      />
    ),
  },
  {
    label: 'Improve',
    value: HomeIntentEnum.Improve,
    icon: (
      <img
        src="/images/player-home-v2/search-bar-icons/lesson-gradient.png"
        className={iconClass}
      />
    ),
  },
  {
    label: 'Get fit',
    value: HomeIntentEnum.GetFit,
    icon: <img src="/images/programming/fitness.png" className={iconClass} />,
  },
  {
    label: 'Book a court',
    value: HomeIntentEnum.BookCourt,
    icon: <img src="/images/player-home-v2/court-green.png" className={iconClass} />,
  },
];
